import { formatMoney } from '../lib/currency';
import React from 'react';
import './ProductNotice.css';
export const SPLIT_REMINDER = 'Double-check the items and amounts before sharing. We can make mistakes.';
export const PAYMENT_RECORD_NOTICE = 'Marking a share changes the bill record. Payments happen in your payment app.';
export function ProductNotice({ children }: { children: React.ReactNode }) {
  return <p className="product-notice">{children}</p>;
}
export function SharingDetails() {
  return <details className="product-sharing-details"><summary>What’s shared</summary><ProductNotice>Receipt photos, names, amounts, notes and receiving details. Links can be forwarded.</ProductNotice></details>;
}
export function PublicLegalLinks() {
  return <nav className="product-legal-links" aria-label="Legal"><a href="/privacy/policy" target="_blank" rel="noopener noreferrer">Privacy policy</a><a href="/terms" target="_blank" rel="noopener noreferrer">Terms of service</a></nav>;
}

export function SplitRoundingNotice({ total, shares, currency = 'USD' }: { total: number; shares: number[]; currency?: string }) {
  if (!shares.length || !Number.isFinite(total) || shares.some(value => !Number.isFinite(value))) return null;
  const roundedShares = shares.reduce((sum, value) => sum + Math.round(value * 100), 0);
  const billMinor = Math.round(total * 100);
  if (roundedShares === billMinor) return null;
  const format = (minor: number) => formatMoney(minor / 100, currency);
  return <ProductNotice>Rounded shares {format(roundedShares)} · Bill total {format(billMinor)}</ProductNotice>;
}
